import { Box, MenuItem, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { NestedMenuItem } from '~/components/Menu';
import AvailabilityStatusIndicator from '~/components/Status/AvailabilityStatusIndicator';
import useAvailableStructureSets from '~/hooks/structure-set/useAvailableStructureSets';
import useStructureSetSelection from '~/hooks/structure-set/useStructureSetSelection';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { cutUID } from '~/utils/string';

export default function AvailableStructuresList({
    onSelect,
}: {
    onSelect: () => void;
}) {
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const availableStructureSets = useAvailableStructureSets(true);
    const { handleSelectLoadedStructureSet, handleSelectSessionStructureSet } =
        useStructureSetSelection({ onSelect });

    return (
        availableStructureSets.length > 1 && (
            <NestedMenuItem label="Change">
                {availableStructureSets.map((set) => {
                    const isLoaded = set.isLoaded;
                    const isActive =
                        currentStructureSet?.dicomUid === set.sopInstanceUID;

                    return (
                        <MenuItem
                            key={set.sopInstanceUID}
                            onClick={() => {
                                if (set.structureSetObject) {
                                    handleSelectLoadedStructureSet(
                                        set.structureSetObject
                                    );
                                } else {
                                    handleSelectSessionStructureSet(
                                        set.sopInstanceUID
                                    );
                                }
                            }}
                            sx={{
                                backgroundColor: isActive
                                    ? 'rgba(0, 0, 0, 0.2)'
                                    : 'inherit',
                                pointerEvents: isActive ? 'none' : 'auto',
                            }}
                        >
                            <Box display="flex">
                                <Box mr={1} ml={-1} width={12}>
                                    <AvailabilityStatusIndicator
                                        isLoaded={isLoaded}
                                        isActive={isActive}
                                    />
                                </Box>
                                <Box>
                                    <Typography color="white" fontSize={14}>
                                        {set.label}
                                    </Typography>
                                    <Box display="flex" gap={0.5}>
                                        <Typography
                                            variant="body2"
                                            fontSize={12}
                                            color={'textSecondary'}
                                        >
                                            {isLoaded ? 'Loaded' : 'Not Loaded'}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            fontSize={12}
                                            color="textSecondary"
                                        >
                                            -{' '}
                                            {cutUID(
                                                set.sopInstanceUID,
                                                4,
                                                6
                                            )}{' '}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </MenuItem>
                    );
                })}
            </NestedMenuItem>
        )
    );
}
